import React, { useState } from "react";
import moment from "moment";
import { useParams } from "react-router-dom";
import { getActivityLogData } from "../../services/chartService";

function ActivityLogs() {
  // const navigateStateGlobal = useLocation();
  const { id } = useParams();
  const [activityLogData, setActivityLogData] = useState();
  const [isLoading, setLoadingState] = useState(false);

  const fetchActivityLogs = async () => {
    setLoadingState(true);
    getActivityLogData(id)
      .then((response) => {
        setActivityLogData(response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoadingState(false);
      });
  };

  // useEffect(() => {
  //   fetchActivityLogs(id);
  //   // eslint-disable-next-line
  // }, [enabled, navigateStateGlobal]);

  return (
    <>
      <div className="col-12 mt-6">
        <div className="card card-flush h-lg-100" onClick={(e) => {
          if (e.target.querySelector("i.fas.fa-plus")) fetchActivityLogs(id);
        }}>
          <div className="card-header py-4 minimize">
            <p className="card-title align-items-start flex-column">
              <span className="fw-bold h4">Activity Logs</span>
              <span className="text-muted mt-1 fw-semibold fs-6">
                History of activity on this chart
              </span>
            </p>
            <div className="card-toolbar mt-0">
              <button className="btn btn-icon btn-sm btn-light-primary justify-content-center minimize" onClick={(e) => {
                e.target.offsetParent.dispatchEvent(
                  new Event("click", { bubbles: true }),
                );
              }}>
                <i className="fas fa-plus" />
              </button>
            </div>
          </div>
          <div className="card-body collapse">
            <div className="m-0">
              <div
                className="timeline"
                style={{ maxHeight: "400px", overflow: "auto" }}
              >
                {isLoading && (
                  <div className="row">
                    <div className="col-12 text-center">
                      <div className="spinner-border h-30px w-30px text-gray-400" />
                    </div>
                  </div>
                )}

                <div className="timeline-item">
                  <div className="timeline-line w-20px" />
                  <div className="timeline-icon symbol symbol-circle symbol-20px"></div>
                </div>
                {!isLoading &&
                  activityLogData?.data?.map((item, index) => (
                    <div key={index}>
                      <div className="timeline-item">
                        <div className="timeline-line w-20px" />
                        <div className="timeline-icon symbol symbol-circle symbol-20px">
                          <div className="symbol-label bg-light">
                            <i className="fa-solid fa-circle-dot fs-9" />
                          </div>
                        </div>
                        <div className="timeline-content">
                          <div className="pe-3 mb-0">
                            <div className="fs-5 fw-semibold mb-0">
                              {item.activity}
                            </div>
                            <div className="overflow-auto pb-0">
                              <div className="d-flex flex-stack align-items-center mt-0 fs-6">
                                <div className="d-flex align-items-center">
                                  <div className="text-muted me-2 fs-7">
                                    {item.timestamp &&
                                      moment(item.timestamp)
                                        .format("MM/DD/YYYY hh:mm:ss a BZ")
                                        .replace("B", "GMT") + " by "}{" "}
                                    <span className="text-primary">
                                      {item.by_user}
                                    </span>
                                  </div>
                                </div>
                                <div className="badge bg-light-info text-info right-end">
                                  {item.timer}
                                </div>
                              </div>
                            </div>
                            <div className="d-flex align-items-center mt-1 fs-6">
                              <div className=" me-2 fs-7">
                                {item.Changed.length === 0 ? "" : <>Changed:</>}

                                {item.Changed.map((item, index) => (
                                  <div key={index}>
                                    <ul className="fs-6">
                                      <li>{item}</li>
                                    </ul>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default React.memo(ActivityLogs);
